import { Directive, Self } from '@angular/core';
import { TabView } from 'primeng/tabview';

@Directive({
  selector: 'p-tabView',
})
/**
 * Automatically sets the scrollable property to true for all p-tabView components.
 * This ensures that tab headers are responsive and scrollable on small screens.
 */
export class TabViewScrollableDirective {
  constructor(@Self() private tabView: TabView) {
    this.tabView.scrollable = true;
  }
}
